export enum PublishResult {
  Ok = 'Ok',
  AlreadyPublished = 'AlreadyPublished',
  Failed = 'Failed',
}

export const PublishSuccessStatuses = [
  PublishResult.Ok,
  PublishResult.AlreadyPublished,
]
